module.exports = __webpack_public_path__ + "img/progress.7602e701.png";